// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autogenerated-palette-icon {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/AutogeneratedPaletteIcon/AutogeneratedPaletteIcon.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ","sourcesContent":[".autogenerated-palette-icon {\n  height: 100%;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
